import { render } from "./ClientMaster.vue?vue&type=template&id=f6fc1016&scoped=true"
import script from "./ClientMaster.vue?vue&type=script&lang=js"
export * from "./ClientMaster.vue?vue&type=script&lang=js"

import "./ClientMaster.vue?vue&type=style&index=0&id=f6fc1016&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_Eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6fc1016"]])

export default __exports__